export default {
  data() {
    return {
      errorMessage: null
    };
  },

  watch: {
    error(newError) {
      if (newError) {
        this.errorMessage = newError;
      }
    }
  },

  created() {
    this.initErrorMessage();
  },

  methods: {
    initErrorMessage() {
      this.errorMessage = this.error;
    }
  },
};
